import { Typography, styled } from '@mui/material';
import theme from '../../../theme';

const ErrorText = styled(Typography)({
    color: theme.palette.error.main,
});

export default ErrorText;
